import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import { Button } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const RenameStoreGroupModal = ({
  isOpen,
  targetGroup,
  onClose,
  onConfirm,
  loading = false,
}) => {
  const [newGroupName, setNewGroupName] = useState("");

  useEffect(() => {
    if (isOpen) {
      setNewGroupName(targetGroup || "");
    }
  }, [isOpen, targetGroup]);

  const handleConfirm = () => {
    const trimmed = newGroupName.trim();
    if (!trimmed || trimmed === targetGroup) {
      return;
    }
    onConfirm(trimmed);
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <h3 style={{ margin: 0 }}>Rename Store Group</h3>
          </Grid>
          <Grid item>
            <CloseIcon onClick={onClose} className="cursor-pointer" />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          size="small"
          label="Group Name"
          value={newGroupName}
          onChange={(e) => setNewGroupName(e.target.value)}
          sx={{ mt: 1 }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={onClose} text="Cancel" size="small" />
        <Button
          variant="primary"
          onClick={handleConfirm}
          text="Save"
          size="small"
          disabled={
            loading || !newGroupName.trim() || newGroupName.trim() === targetGroup
          }
        />
      </DialogActions>
    </Dialog>
  );
};

RenameStoreGroupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  targetGroup: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default RenameStoreGroupModal;
